if (!customElements.get('ttd-event-list')) {
  customElements.define(
    'ttd-event-list',
    class TtdEventList extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-event-track]');
        this.emptyState = this.querySelector('[data-event-empty]');
        this.resultCount = this.querySelector('[data-event-result-count]');
        this.carouselControls = this.querySelector('[data-event-controls]');

        if (!this.track) return;

        this.cards = Array.from(this.querySelectorAll('[data-event-card]'));
        this.cards.sort((left, right) => Date.parse(left.dataset.start) - Date.parse(right.dataset.start));
        this.cards.forEach((card) => this.track.appendChild(card));

        const eventsPath = new URL(this.dataset.eventsUrl, window.location.origin).pathname.replace(/\/$/, '');
        this.activeFilter = window.location.pathname.startsWith(`${eventsPath}/`)
          ? window.location.pathname.slice(eventsPath.length + 1).split('/')[0]
          : 'all';
        this.buildFilters();
        this.bindScrollButtons();
        this.updateVisibleCards();
      }

      buildFilters() {
        const filterGroup = this.querySelector('[data-event-filters]');
        if (!filterGroup) return;

        const games = new Map();
        this.cards.forEach((card) => {
          if (card.dataset.game) games.set(card.dataset.game, card.dataset.gameLabel || card.dataset.game);
        });
        [...games.entries()].sort((left, right) => left[1].localeCompare(right[1])).forEach(([game, label]) => {
          const link = document.createElement('a');
          link.href = `${this.dataset.eventsUrl}/${game}`;
          link.dataset.eventFilter = game;
          link.textContent = label;
          filterGroup.appendChild(link);
        });

        filterGroup.querySelectorAll('[data-event-filter]').forEach((filterLink) => {
          const isActive = filterLink.dataset.eventFilter === this.activeFilter;
          filterLink.classList.toggle('is-active', isActive);
          if (isActive) filterLink.setAttribute('aria-current', 'page');
          else filterLink.removeAttribute('aria-current');
        });

        filterGroup.addEventListener('click', (event) => {
          const button = event.target.closest('[data-event-filter]');
          if (!button) return;
          event.preventDefault();

          this.activeFilter = button.dataset.eventFilter;
          filterGroup.querySelectorAll('[data-event-filter]').forEach((filterButton) => {
            const isActive = filterButton === button;
            filterButton.classList.toggle('is-active', isActive);
            if (isActive) filterButton.setAttribute('aria-current', 'page');
            else filterButton.removeAttribute('aria-current');
          });
          this.updateVisibleCards();
        });
      }

      bindScrollButtons() {
        this.querySelectorAll('[data-event-scroll]').forEach((button) => {
          button.addEventListener('click', () => {
            const firstVisibleCard = this.cards.find((card) => !card.hidden);
            const distance = firstVisibleCard ? firstVisibleCard.getBoundingClientRect().width + 24 : this.track.clientWidth;
            const direction = button.dataset.eventScroll === 'previous' ? -1 : 1;
            const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            this.track.scrollBy({ left: distance * direction, behavior: reduceMotion ? 'auto' : 'smooth' });
          });
        });
      }

      updateVisibleCards() {
        const limit = Number.parseInt(this.dataset.limit, 10) || this.cards.length;
        const isCarousel = this.dataset.layout === 'carousel';
        let visibleCount = 0;

        this.cards.forEach((card) => {
          const matchesFilter = this.activeFilter === 'all' || card.dataset.game === this.activeFilter;
          const withinLimit = !isCarousel || visibleCount < limit;
          card.hidden = !matchesFilter || !withinLimit;
          if (matchesFilter && withinLimit) visibleCount += 1;
        });

        if (this.carouselControls) this.carouselControls.hidden = visibleCount < 2;
        if (this.emptyState) this.emptyState.hidden = visibleCount > 0;
        if (this.resultCount) {
          this.resultCount.textContent = `${visibleCount} upcoming event${visibleCount === 1 ? '' : 's'}`;
        }
      }
    },
  );
}
